import { useQuery } from '@tanstack/react-query';
import { api } from 'constants/api';

import { ApiResponse } from 'types/utils/api-response';
import { MessageTemplateResponseType } from './useGetMessagesTemplates';

const isStaging =
  process.env.REACT_APP_API_URL === 'https://pjstaging.consultmyapp.com/api';

export const useGetBlankTemplate = () => {
  return useQuery({
    queryKey: ['blank-template'],
    queryFn: async () => {
      const { data } = await api.get<ApiResponse<MessageTemplateResponseType>>(
        isStaging
          ? `/campaign/templates/list?tag=Blank&channel=sms`
          : `/campaign/templates/list?tag=UI_Tool_Blank&channel=sms`
      );

      return data.data;
    },
  });
};
